'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'wand-magic-sparkles';
var width = 576;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = ['M0 128L64 96 96 32l32 64 64 32-64 32L96 224 64 160 0 128zM192 64l42.7-21.3L256 0l21.3 42.7L320 64 277.3 85.3 256 128 234.7 85.3 192 64zm120 56l80.4-80.4L432 0l39.6 39.6 32.8 32.8L544 112l-39.6 39.6L424 232l-39.6-39.6L464.8 112 432 79.2l-80.4 80.4c-13.2-13.2-26.4-26.4-39.6-39.6zm40 264l64-32 32-64 32 64 64 32-64 32-32 64-32-64-64-32z', 'M424 232L312 120 32 400 144 512 424 232z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;